/*
    Controller for connecting the logs eventstream.
    See collections/v5/logstream for most information about this. 
    You probably don't need to do anything with this controller. Logstream should be connected once,
    on app start after login.
*/

import logstream from '@/collections/v5/logstream';

    function connect_logstream() {
        logstream.connect();
    }
    export default connect_logstream;
